import CardHeader from '@/components/Includes/CardHeader/CardHeader.vue';
import IAdminPanel from "@/interfaces/IAdminPanel";
import IOperationSystems from "@/interfaces/IOperationSystems";
import DesktopApps from "@/libs/desktopApps";
import {Component, Vue} from 'vue-property-decorator';
import {Action} from "vuex-class";

@Component({
    name: 'Dashboard',
    components: {
        CardHeader,
    }
})
export default class Dashboard extends Vue {
    @Action private getApp!: (osName: string) => Promise<void>;

    private operationSystems: IOperationSystems[] = [
        DesktopApps.mac,
        DesktopApps.linux,
        DesktopApps.windows
    ];

    private adminPanels: IAdminPanel[] = [
        {
            name: 'Switcherry',
            version: undefined,
            released: undefined,
            icon: ''
        },
        {
            name: 'Astrology',
            version: undefined,
            released: undefined,
            icon: ''
        }
    ];

    private async downloadApp(operationSystem: string): Promise<void> {
        await this.getApp(operationSystem);
    }
}